module.exports = __webpack_public_path__ + "img/Frisur.9c9b78d5.svg";